import { Grid2 as Grid, Typography, useTheme } from '@mui/material';
import { getTemplatesViewSx } from '@src/components/_shared/sxStyles/Config/templates';
import { ControlModes } from '@src/types/Stacks';
import TemplatesCardStatuses from '../TemplatesCardStatuses';
import { StatusType } from './types';

interface TemplateCardHeaderProps {
  controlMode: ControlModes;
  isDefault?: boolean;
  scadaStatus: number | undefined;
  activeStatus: number | undefined;
  hmiStatus: number | undefined;
  statusTypes: StatusType[];
}

export const TemplateCardHeader = ({
  controlMode,
  isDefault,
  scadaStatus,
  activeStatus,
  hmiStatus,
  statusTypes,
}: TemplateCardHeaderProps) => {
  const theme = useTheme();
  const templatesViewSx = getTemplatesViewSx(theme);

  return (
    <Grid size={4} sx={templatesViewSx.templateNameGrid}>
      <Typography sx={templatesViewSx.templateName}>
        {controlMode.stackAlias ?? controlMode.name}
      </Typography>
      {isDefault && (
        <TemplatesCardStatuses
          scadaStatus={scadaStatus}
          activeStatus={activeStatus}
          hmiStatus={hmiStatus}
          statusTypes={statusTypes}
        />
      )}
    </Grid>
  );
};
